import { Button } from "@shared/components/ui/Button";
import React from "react";
import { useNavigate } from "react-router-dom";
import theme from "../../../shared/utils/themeColors";
import OnboardingLayout from "../components/OnboardingLayout";
import { useOnboarding } from "../hooks/useOnboarding";
import { OnboardingStep } from "../types";

/**
 * Fourth step of onboarding - Completion
 */
const Onboarding04Page: React.FC = () => {
  const {
    organizationType,
    organizationInfo,
    profileInfo,
    loading,
    error,
    completeOnboarding,
  } = useOnboarding();

  const navigate = useNavigate();

  // Handle completion
  const handleComplete = () => {
    completeOnboarding();
  };

  return (
    <OnboardingLayout currentStep={OnboardingStep.COMPLETE}>
      <div className="text-center">
        <div
          className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4"
          style={{ backgroundColor: "#6DAF39" }}
        >
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h1 className={`text-3xl ${theme.text.primary} mb-12 font-bold`}>
          Nice to have you as a GCCA member, {organizationInfo?.name}. 🙌
        </h1>

        {error && (
          <div className="mb-6 p-3 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-lg">
            {error}
          </div>
        )}

        {/*  <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6 mb-8 text-left">
          <h2 className={`text-xl ${theme.text.primary} mb-4`}>
            Your Information
          </h2>

          <div className="space-y-4">
            <div>
              <h3 className={`text-sm font-medium ${theme.text.secondary}`}>
                Membership Type
              </h3>
              <p className={`text-base ${theme.text.primary}`}>
                {organizationType === OrganizationType.ORGANIZATION
                  ? "Organization"
                  : "Corporate Member"}
              </p>
            </div>

            {organizationInfo && (
              <div>
                <h3 className={`text-sm font-medium ${theme.text.secondary}`}>
                  Organization
                </h3>
                <p className={`text-base ${theme.text.primary}`}>
                  {organizationInfo.name}
                </p>
                {organizationInfo.city && organizationInfo.state && (
                  <p className={`text-sm ${theme.text.secondary}`}>
                    {organizationInfo.city}, {organizationInfo.state},{" "}
                    {organizationInfo.country}
                  </p>
                )}
              </div>
            )}

            {profileInfo && (
              <div>
                <h3 className={`text-sm font-medium ${theme.text.secondary}`}>
                  Profile
                </h3>
                <p className={`text-base ${theme.text.primary}`}>
                  {profileInfo.name}
                </p>
                {profileInfo.role && (
                  <p className={`text-sm ${theme.text.secondary}`}>
                    {profileInfo.role}
                  </p>
                )}
              </div>
            )}
          </div>
        </div> */}

        <div className="flex items-center justify-between">
          <Button
            type="button"
            onClick={() => navigate("/onboarding-3")}
            variant="secondary"
          >
            ← Back to Profile
          </Button>

          <Button onClick={handleComplete} variant="primary" disabled={loading}>
            {loading ? "Completing..." : "Go to Portal →"}
          </Button>
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default Onboarding04Page;
